import {kebabCase} from 'lodash'
const generateSlug = (title) =>{
   return kebabCase(title.toLowerCase())
}

export default generateSlug